/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../../Labels.js';

/**
 * Animals theme with cute animal emojis (premium content).
 */
export class ReptilesTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'reptiles',
            'Reptiles',
            allLabels.reptiles,
            { numPairs: 7, ...options }
        );
    }
}
